(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geronimo-cookie"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel=document.getElementById('geronimo-cookie');
  if(!panel || panel.dataset.ready) return;
  panel.dataset.ready='true';
  const get=id=>document.getElementById(id);
  const reopen=get('gc-reopen'),options=get('gc-options'),status=get('gc-status');
  const categories=['preferences','analytics','marketing'];
  let api=null,busy=false,previousFocus=null,loadedCombined=false,loadedAnalytics=false;
  const consent=()=>api.currentVisitorConsent();
  const decided=()=>categories.every(key=>['yes','no'].includes(consent()[key]));
  function expand(value){options.hidden=!value;get('gc-settings').setAttribute('aria-expanded',String(value));}
  function show(settings=false,focus=false){
    previousFocus=document.activeElement;
    panel.hidden=false;reopen.hidden=true;reopen.setAttribute('aria-expanded','true');
    expand(settings);get('gc-close').hidden=!api||!decided();
    if(api)categories.forEach(key=>{panel.querySelector('[name="'+key+'"]').checked=consent()[key]==='yes';});
    if(focus)get('gc-settings').focus();
  }
  function hide(){panel.hidden=true;reopen.hidden=false;reopen.setAttribute('aria-expanded','false');if(panel.contains(document.activeElement)){(previousFocus?.isConnected && previousFocus!==document.body ? previousFocus:reopen).focus();}}
  function activate(group){
    document.querySelectorAll('script[type="text/plain"][data-geronimo-consent="'+group+'"]').forEach(source=>{
      const script=document.createElement('script');script.textContent=source.textContent;source.replaceWith(script);
    });
    if(group==='combined')document.dispatchEvent(new Event('geronimo:tracking-ready'));
  }
  function sync(){
    const c=consent(),analytics=c.analytics==='yes',marketing=c.marketing==='yes',preferences=c.preferences==='yes';
    window.gtag('consent','update',{analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied',functionality_storage:preferences?'granted':'denied',personalization_storage:preferences?'granted':'denied'});
    if((loadedCombined&&!(analytics&&marketing))||(loadedAnalytics&&!analytics)){window.location.reload();return;}
    if(analytics&&!loadedAnalytics){loadedAnalytics=true;activate('analytics');}
    if(analytics&&marketing&&!loadedCombined){loadedCombined=true;activate('combined');}
  }
  function saving(value){busy=value;panel.querySelectorAll('button').forEach(b=>b.disabled=value);}
  function save(values){
    if(busy)return;
    if(!api){status.textContent=status.dataset.error;load();return;}
    saving(true);status.textContent='';
    const timer=setTimeout(()=>{saving(false);status.textContent=status.dataset.error;},8000);
    try{api.setTrackingConsent({...values,sale_of_data:false},()=>{
      clearTimeout(timer);saving(false);
      const saved=consent();
      if(!categories.every(k=>saved[k]===(values[k]?'yes':'no'))){status.textContent=status.dataset.error;return;}
      hide();sync();
    });}catch(error){clearTimeout(timer);saving(false);status.textContent=status.dataset.error;}
  }
  get('gc-accept').addEventListener('click',()=>save({preferences:true,analytics:true,marketing:true}));
  get('gc-reject').addEventListener('click',()=>save({preferences:false,analytics:false,marketing:false}));
  get('gc-save').addEventListener('click',()=>save(Object.fromEntries(categories.map(k=>[k,panel.querySelector('[name="'+k+'"]').checked]))));
  get('gc-settings').addEventListener('click',()=>expand(options.hidden));
  get('gc-close').addEventListener('click',hide);
  reopen.addEventListener('click',()=>show(true,true));
  panel.addEventListener('keydown',e=>{if(e.key==='Escape'&&api&&decided()){e.preventDefault();hide();}});
  document.addEventListener('visitorConsentCollected',()=>{if(api){sync();if(!busy&&decided())hide();}});
  let attempts=0,loading=false;
  function load(){
    if(loading)return;
    if(!window.Shopify?.loadFeatures){if(attempts++<40)setTimeout(load,250);else{show();status.textContent=status.dataset.error;}return;}
    loading=true;
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
      loading=false;
      if(error||!window.Shopify.customerPrivacy){show();status.textContent=status.dataset.error;return;}
      api=window.Shopify.customerPrivacy;status.textContent='';sync();
      if(decided()){reopen.hidden=false;}else show();
    });
  }
  load();
})();
  } catch(e) { console.error(e); }
})();

})();
